import styles from './Currency.module.css';

import type { FC } from 'react';
import type { PayoutCurrency, Currency as FiatCurrency } from 'src/types/listing';

import classNames from 'classnames';

interface CurrencyProps {
  dark?: boolean;
  /** @deprecated Pass `fiat` — a listing priced in euro must not be badged with a dollar sign. */
  usd?: boolean;
  /** Settlement token of the amount next to it (USDT, USDC, EURC, TON). */
  currency?: PayoutCurrency;
  /** Fiat currency of the amount next to it — the listing's own, never assumed. */
  fiat?: FiatCurrency;
}

/**
 * The round badge next to an amount, naming the money it is in.
 *
 * Two kinds live here: settlement tokens (what actually moves on a chain) and fiat currencies
 * (what the car is priced in). They are separate props because they are separate facts — a EUR
 * listing settles in EURC, and reading the token off the dealer's payout preference, or the fiat
 * sign off a hardcoded dollar, is how a euro car came to be shown as "$".
 */
export const Currency: FC<CurrencyProps> = ({ dark, usd, currency, fiat }) => {
  const fiatCode = fiat ?? (usd ? 'USD' : undefined);

  if (fiatCode) {
    return <div className={classNames(styles.container, fiatCode === 'EUR' ? styles.eur : styles.usd)} />;
  }

  const tokenClass =
    currency === 'TON'
      ? styles.ton
      : currency === 'USDT'
        ? styles.usdt
        : currency === 'USDC'
          ? styles.usdc
          : currency === 'EURC'
            ? styles.eurc
            : dark
              ? styles.dark
              : undefined;

  return <div className={classNames(styles.container, tokenClass)} />;
};
